import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  copyrightContent: {
    flexGrow: 1,
    [theme.breakpoints.up("md")]: {
      paddingRight: "30px",
      textAlign: "right",
    },
  },
  copyrightContainer: {
    alignItems: "center",
    display: "flex",
  },
  footer: {
    padding: 5,
    textAlign: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 2px 2px 1px rgba(0,0,0,0.63)",
    height: "auto",
    width: "100%",
    marginLeft: 0,
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      height: "48px",
      position: "fixed",
      bottom: 0,
      right: 0,
      display: "flex",
      alignItems: "center",
    },
  },
  notHamburguer: {
    padding: 5,
    textAlign: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 2px 2px 1px rgba(0,0,0,0.63)",
    height: "auto",
    width: "100%",
    marginLeft: 0,
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      height: "48px",
      position: "fixed",
      bottom: 0,
      right: 0,
      width: `calc(100% - ${theme.sizes.drawer.desktopWidth}px)`,
      marginLeft: theme.sizes.drawer.desktopWidth,
      display: "flex",
      alignItems: "center",
    },
  },
  content: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  copyright: {
    marginRight: theme.spacing(5),
  },
  button: {
    marginLeft: theme.spacing(0),
  },
  buttonLabel: {
    color: "#666666",
    textTransform: "capitalize",
  },
}));

export default useStyles;
